export const heroIncludes = [
  "Instant digital access",
  "Six specialized educational volumes",
  "Five exclusive bonuses",
  "Visual reference tables and worksheets",
  "Simulated clinical case exercises",
  "No monthly subscription",
  "Seven-day satisfaction guarantee",
];

export const monitorParameters = [
  { abbr: "MAP", label: "Mean arterial pressure" },
  { abbr: "CO", label: "Cardiac output" },
  { abbr: "CI", label: "Cardiac index" },
  { abbr: "CVP", label: "Central venous pressure" },
  { abbr: "SVR", label: "Systemic vascular resistance" },
  { abbr: "SV", label: "Stroke volume" },
];

export const extraConcepts = ["Preload and afterload", "Contractility", "Tissue perfusion"];

export const beforeItems = [
  "You spend too much time searching through textbooks, lecture notes, and disconnected resources.",
  "You recognize hemodynamic abbreviations but struggle to remember how different parameters relate.",
  "You memorize individual values without consistently reviewing their physiological meaning.",
  "You find preload, afterload, and contractility difficult to distinguish.",
  "You want to understand advanced monitoring concepts but don’t know how to organize your study.",
  "You lack structured educational cases for practicing hemodynamic reasoning.",
];

export const afterItems = [
  "You have six organized volumes dedicated to hemodynamic monitoring education.",
  "You can review essential cardiovascular parameters using clear visual references.",
  "You have dedicated explanations of preload, afterload, and contractility.",
  "You can compare monitoring parameters and their limitations using structured tables.",
  "You can use guided worksheets to organize physiological concepts.",
  "You can practice reasoning through simulated hemodynamic monitoring cases.",
];

export const situations = [
  {
    title: "You want to understand what hemodynamic parameters actually represent.",
    body: "You recognize MAP, CO, CI, CVP, and SVR, but you want a clearer explanation of their physiological meaning and limitations.",
  },
  {
    title: "You struggle to connect cardiovascular physiology with monitoring concepts.",
    body: "You understand individual definitions, yet organizing the relationships between preload, afterload, contractility, and cardiac output can feel complicated.",
  },
  {
    title: "You want a clearer reference for interpreting hemodynamic trends.",
    body: "You know that isolated measurements have limitations. You want educational materials that explain why changes over time and clinical context matter.",
  },
  {
    title: "You find advanced monitoring terminology overwhelming.",
    body: "Different monitoring technologies, measurement methods, and cardiovascular parameters can make studying hemodynamics feel unnecessarily complex.",
  },
  {
    title: "You want more than a list of normal values.",
    body: "You want visual diagrams, comparison tables, explanations, and guided exercises that help you understand the concepts behind the measurements.",
  },
  {
    title: "You want to practice clinical reasoning.",
    body: "You want simulated cases that encourage you to organize findings, recognize missing information, and consider alternative explanations.",
  },
];

export const studyTools = [
  {
    title: "The Hemodynamic Parameter Comparison Matrix",
    body: "Compare selected cardiovascular parameters, definitions, physiological relationships, and interpretation limitations.",
  },
  {
    title: "The Cardiac Performance Concept Worksheet",
    body: "Organize your understanding of preload, afterload, contractility, stroke volume, and cardiac output.",
  },
  {
    title: "The Hemodynamic Trend Review Template",
    body: "Practice organizing changes in monitoring parameters over time through educational scenarios.",
  },
  {
    title: "The Perfusion Concept Reference Sheet",
    body: "Review selected concepts related to tissue perfusion, oxygen delivery, and cardiovascular physiology.",
  },
  {
    title: "The Hemodynamic Clinical Reasoning Worksheet",
    body: "Use structured prompts to organize findings, identify missing information, and explain your reasoning.",
  },
];

export const offerItems = [
  { label: "Hemodynamic Monitoring Blueprint™ — 6 Premium Volumes", value: "$162" },
  { label: "Bonus #1 — Hemodynamic Monitoring Quick-Reference Cards", value: "$17" },
  { label: "Bonus #2 — The 15-Minute Hemodynamic Study Review", value: "$12" },
  { label: "Bonus #3 — Hemodynamic Interpretation Mistakes Library", value: "$17" },
  { label: "Bonus #4 — Hemodynamic Clinical Case Practice Pack", value: "$17" },
  { label: "Bonus #5 — Hemodynamic Monitoring Study Checklist Collection", value: "$12" },
];

export const offerIncludes = [
  "Six premium educational volumes",
  "Five complementary bonuses",
  "Visual reference tables and comparison tools",
  "Hemodynamic monitoring worksheets",
  "Simulated clinical case exercises",
  "Digital access to purchased materials",
  "No monthly subscription",
];

export const guaranteeItems = [
  "All six educational volumes",
  "The hemodynamic parameter reference atlas",
  "The cardiovascular physiology materials",
  "The advanced monitoring references",
  "The simulated clinical cases",
  "All five complementary bonuses",
];

export const finalIncludes = [
  "Six premium hemodynamic monitoring volumes",
  "Five exclusive educational bonuses",
  "Cardiovascular physiology diagrams",
  "Hemodynamic parameter comparison tables",
  "Advanced monitoring reference materials",
  "Practical worksheets and checklists",
  "Simulated clinical case exercises",
  "Focused 15-minute study resources",
];
